import {emptyForm} from '../../utils/objectCreationDraft';

export default {
    namespaced: true,
    state: () => ({form: emptyForm('aerodorstroy'), session: {ready: false, status: 'idle', localOk: true}}),
    mutations: {
        form(state, value) { state.form = value; },
        session(state, value) { state.session = value; },
        reset(state) { state.form = emptyForm('aerodorstroy'); state.session = {ready: false, status: 'idle', localOk: true}; }
    }
};
